export const SET_IS_LOADING_CATEGORY = "SET_IS_LOADING_CATEGORY/category-page";
export const SET_CATEGORIES = "SET_CATEGORIES/category-page";
export const SET_PAGINATION_DATA = "SET_PAGINATION_DATA/category-page";

export const CATEGORY_SET_CUSTOMER_LIST = 'CATEGORY_SET_CUSTOMER_LIST/category-page'
export const CATEGORY_SET_SELECTED_CUSTOMER_LIST = 'CATEGORY_SET_SELECTED_CUSTOMER_LIST/category-page'
export const CATEGORY_SET_TARGETING_TYPE_LIST = 'CATEGORY_SET_TARGETING_TYPE_LIST/category-page'
